import {React} from 'external/react'
import {
    clsx,
    Dialog,
    IconButton,
    CloseIcon,
} from 'external/material'


export default function FullScreenDialog(props) {

    const {
        open,
        closePosition = 'start',
        className,
        handleClose,
        TransitionComponent,
        children
    } = props

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            className={clsx('dialog-root', className)}
            TransitionComponent={TransitionComponent}
            fullScreen
            disableEscapeKeyDown
        >
                    {handleClose && (<IconButton
                        sx={{position: 'fixed', right: 6, top: 6}}
                        edge={closePosition}
                        color="inherit"
                        onClick={handleClose}
                        aria-label="close"
                        className="dialog-close-button"
                    >
                        <CloseIcon />
                    </IconButton>)}

        {children}
    </Dialog>
    )
}
